<template>
  <div id>
    <v-dialog v-model="$store.state.show_terms" :max-width="700" persistent>
      <v-card>
        <v-card-title class="secondary white--text">
          <h5>WhyBuy User Agreement</h5>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="pt-4" style="max-height:450px;overflow-y:auto">
          <p v-html="$store.state.website.terms"></p>
        </v-card-text>

        <v-card-actions class="grey lighten-3">
          <v-spacer></v-spacer>
          <v-btn text @click="logout">Sign Out</v-btn>
          <v-btn color="primary" @click="accept" :loading="loading">I agree</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  created() {},
  data: () => ({
    loading: false
  }),
  computed: {},
  methods: {
    logout(){
      this.$store.commit('logout')
    },
    async accept() {
      this.loading = true;
      await this.$store.dispatch("acceptTerms");
      this.loading = false;
    }
  }
};
</script>

<style>
</style>